import React, { useState } from "react";
import {
  CheckboxLabel,
  StyledBox,
  StyledHr,
} from "./ContactOverview";
import StyledToolTip from "../../../components/StyledComponents/StyledTooltip";
import TooltipIcon from "../../../assets/icons/Tooltip";
import StyledText from "../../../components/StyledComponents/StyledText";
import { CorporateTheme, CreateFormTheme } from "../../../utils/themes";
import styled from "styled-components";
import EditIcon from "../../../assets/icons/EditIcon";
import DeleteIcon from "../../../assets/icons/DeleteIcon";
import CustomInput from "../../../components/form/CustomInput";
import { Col, Row } from "react-bootstrap";
import { Button } from "../../../components/form/Button";
import PlusIcon from "../../../assets/icons/PlusIcon";
import TickIcon from "../../../assets/icons/TickIcon";
import CrossIcon from "../../../assets/icons/CrossIcon";
import { useTheme } from "../../../middleware/ThemeContext";

interface ContactAddressesProps {
  data: any; // Replace 'any' with a more specific type if available
}

const ContactAddresses: React.FC<ContactAddressesProps> = ({ data }) => {
  const { theme } = useTheme();
  const [editMode, setEditMode] = useState(false);
  const [formData, setFormData] = useState<{
    [key: number]: { [key: string]: any };
  }>({});
  // /const [makeAddressPrimary, setmakeAddressPrimary] = useState<{ [key: number]: boolean }>({});
  const [makeAddressPrimary, setMakeAddressPrimary] = React.useState<
    number | null
  >(null); // Only one index can be primary

  const [useOrganizationPhone, setUseOrganizationPhone] = useState(false);
  const [addressFields, setAddressFields] = useState<number[]>([0]); // Array of address indexes

  const fields = [
    {
      name: "addressTitle",
      inputType: "text",
      label: "Address Title",
      placeholder: "Enter address title",
    },
    {
      name: "address",
      inputType: "text",
      label: "Address",
      placeholder: "Enter address",
    },
  ];

  const handleCheckboxChangePhone = () => {
    setUseOrganizationPhone((prev: boolean) => !prev);
  };

  const handleFieldChange = (index: number, name: string, value: string) => {
    setFormData((prev) => ({
      ...prev,
      [index]: {
        ...prev[index],
        [name]: value,
      },
    }));
  };

  const handlePrimaryChange = (index: number) => {
    setMakeAddressPrimary(index);
  };

  // const handleCheckboxChange = (index: number) => {
  //   setmakeAddressPrimary((prev?:any) => ({
  //     ...prev,
  //     [index]: !prev[index],
  //   }));
  // };

  const handleAddAddress = () => {
    setAddressFields((prev) => [...prev, prev.length]); // Add a new index
  };

  return (
    <StyledBox
      theme={theme}
      className={`mt-2 `}
      bgColor={editMode ? theme.CorporateTheme.colors?.bannerBg : theme.CorporateTheme.colors?.headerBG}
    >
      <div className="d-flex align-items-center justify-content-between px-3">
        <StyledText
          fontSize="16px"
          fontWeight={700}
          textColor={theme.CorporateTheme.colors.headerColor}
          className="mb-0 ps-3 py-3"
        >
          Addresses
        </StyledText>
        {editMode ? (
          <div className="d-flex align-items-center gap-2 ">
            <TickIcon size={24} className="cursor-pointer" />
            <CrossIcon
              color={theme.CorporateTheme.colors.textSecondary}
              size={24}
              className="cursor-pointer"
              onClick={() => setEditMode(false)}
            />
          </div>
        ) : (
         '' 
          // <EditIcon
          //   className="cursor-pointer"
          //   onClick={() => setEditMode(true)}
          // />
        )}
      </div>
      <StyledHr theme={theme} className="me-4" />
      <div
        className={`d-flex ${
          editMode ? "align-items-start" : "align-items-center"
        } px-3 py-3 overflow-x-auto`}
      >
        {/* {[1, 2, 3].map((item, index) => ( */}
        <>
          <StyledAddressBar
            className={editMode ? "border border-1 bg-white py-3 rounded" : ""}
          >
            {/* <StyledText
                fontSize="14px"
                fontWeight={600}
                textColor={CorporateTheme.colors.textSecondary}
                className="ps-3"
              >
                Main Office London
              </StyledText> */}
            <StyledText
              fontSize="14px"
              fontWeight={400}
              textColor={theme.CorporateTheme.colors.textSecondary}
              className="ps-3"
            >
              {
                data?.cfr?.formSubmissions?.submissionValues?.find(
                  (val: any) => val?.field?.name === "address"
                )?.value
              }
            </StyledText>
          </StyledAddressBar>
          {editMode && <DeleteIcon size={26} className="cursor-pointer" />}
          {/* {index !== 3 - 1 && !editMode && <StyledVr className="my-2" />} */}
        </>
        {/* ))} */}
      </div>
      {editMode && (
        <div className="px-4">
          <DashedBorder theme={theme}>
            {addressFields.map((addressIndex) => (
              <div key={addressIndex} className="mb-3">
                <Row className="w-90">
                  {fields.map((field, index) => (
                    <Col lg={6} key={index}>
                      <div className="d-flex flex-column gap-2">
                        <StyledText
                          fontSize="14px"
                          fontWeight={600}
                          textColor={theme.CorporateTheme.colors.textSecondary}
                        >
                          {field.label}
                        </StyledText>
                        <CustomInput
                          value={formData[addressIndex]?.[field.name] || ""}
                          onChange={(value) => {
                            const processed =
                              field.inputType === "number"
                                ? value.replace(/\D/g, "")
                                : value;
                            handleFieldChange(
                              addressIndex,
                              field.name,
                              processed
                            );
                          }}
                          placeholder={field.placeholder}
                          type={field.inputType}
                        />
                      </div>
                    </Col>
                  ))}
                </Row>

                <div
                  style={{
                    color: theme.CorporateTheme.colors?.textSecondary,
                    borderStyle: "dashed",
                    borderColor: theme.CreateFormTheme.colors?.inputBorders,
                  }}
                  className="rounded bg-white border-1 mt-3 p-2 d-flex align-items-center justify-content-between"
                >
                  <CheckboxLabel>
                    <input
                      type="checkbox"
                      checked={makeAddressPrimary === addressIndex}
                      onChange={() => handlePrimaryChange(addressIndex)}
                    />
                    Mark this as primary address
                  </CheckboxLabel>

                  <StyledToolTip
                    placement="bottom"
                    title={`This contact's address will be linked to the organization's address. Any updates to the organization's address will reflect here automatically.`}
                  >
                    <TooltipIcon size={22} className="cursor-pointer" />
                  </StyledToolTip>
                </div>
              </div>
            ))}

            <Button
              theme={theme}
              type="button"
              $variant="add"
              className="mt-3"
              onClick={handleAddAddress}
            >
              <PlusIcon size={10} /> Add New Address
            </Button>
          </DashedBorder>
        </div>
      )}

      {!editMode && (
        <div
          style={{
            color: theme.CorporateTheme.colors?.textSecondary,
            backgroundColor: theme.CorporateTheme?.colors?.filterBG,
          }}
          className="rounded-bottom-1 p-3  d-flex align-items-center justify-content-between"
        >
          <CheckboxLabel>
            <input
              type="checkbox"
              checked={useOrganizationPhone}
              onChange={handleCheckboxChangePhone}
            />
            Use organization’s address instead of this primary address
          </CheckboxLabel>

          <StyledToolTip
            placement="bottom"
            title={`This contact's address will be linked to the organization's address. Any updates to the organization's address will reflect here automatically.`}
          >
            <TooltipIcon size={22} className="cursor-pointer" />
          </StyledToolTip>
        </div>
      )}
    </StyledBox>
  );
};

export default ContactAddresses;

const StyledAddressBar = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 4px;
  padding: 10px;
  max-width: 30%;
  min-width: 30%;
  margin: 4px 10px;
`;

export const DashedBorder = styled.div(({ theme }) => ({
  border: `2px dashed ${theme.CreateFormTheme?.colors?.inputBorders}`,
  backgroundColor: theme.CorporateTheme.colors.background,
  padding: '10px',
  borderRadius: '4px',
  display: 'flex',
  flexDirection: 'column',
}));
